import React from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

const VentajasPisoDeckSintetico = () => {
  return (
    <section className="pb-lg-22">
      <div className="container">
        <div className="row align-items-center mt-n1-6 mt-sm-n6">
          <div className="col-lg-5 mt-1-6 mt-sm-6">
            <div className="position-relative text-center text-lg-start">
              <img 
                src="/assets/img/productos/piso-deck-sintetico/piso-deck-sintetico-ventajas.jpg" 
                alt="piso de caucho fabricado con material reciclado" 
              />
              <div className="position-absolute bottom-n10 right-n10 right-lg-n30 d-none d-sm-block">
                <img 
                  src="/assets/img/productos/piso-deck-sintetico/piso-deck-sintetico-small-ventajas.png" 
                  alt="piso de caucho fabricado con material reciclado" 
                  style={{ width: '300px', height: '300px' }} 
                />
              </div>
            </div>
          </div>
          <div className="col-lg-7 mt-1-6 mt-sm-6">
            <div className="ps-lg-2-9 ps-xl-10">
              <div className="mb-1-9 mb-xl-8">
                <span className="text-primary text-uppercase small letter-spacing-4 d-block font-weight-700 mb-2">Contamos con entrega inmediata</span>
                <h2 className="mb-1-6 display-5 font-weight-800 lh-1">Ventajas para Profesionales del Diseño y la Construcción:</h2>
              </div>
              <div className="ps-1-9 ps-sm-10 ps-lg-20">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <i className="fas fa-check-circle text-primary me-2"></i>
                    <strong>Disponibilidad Inmediata:</strong> Contamos con un amplio stock listo para entrega, asegurando que tus proyectos no sufran retrasos por falta de materiales.
                  </li>
                  <li className="mb-3">
                    <i className="fas fa-check-circle text-primary me-2"></i>
                    <strong>Asesoría Especializada:</strong> Nuestro equipo de expertos está disponible para brindarte el soporte necesario en la selección e instalación del deck sintético, garantizando resultados que superen las expectativas de tus clientes.
                  </li>
                  <li>
                    <i className="fas fa-check-circle text-primary me-2"></i>
                    <strong>Compromiso con la Sostenibilidad:</strong> Nuestros productos están diseñados pensando en el medio ambiente, ofreciendo soluciones ecológicas que contribuyen a la construcción responsable y sostenible.
                  </li>
                </ul>
                <a href="contacto-decototal" className="butn-style4 secondary"><span>Cotiza con nosotros</span></a>
                <BannerNoInstalacion />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VentajasPisoDeckSintetico;
